// ===== POC Cuidados Paliativos (PNCP) - perfil SUS do profissional =====
// Substitui o antigo mocks/palliativeProfessionalStorage.js.
//   - da pessoa: CNS e certificação em CP;
//   - de cada vínculo com equipe: CBO e carga horária semanal (no CNES, os dois
//     são do vínculo com o estabelecimento, não da pessoa).

import { apiGet, apiPut } from "./http";

export const CERTIFICATE_OPTIONS = [
  { _id: "especializacao", name: "Especialização" },
  { _id: "aperfeicoamento", name: "Aperfeiçoamento" },
  { _id: "unasus", name: "Trilhas UNA-SUS" }
];

export function emptyProfessionalProfile() {
  return {
    cns: "",
    certificateType: "",
    certificateHours: "",
    // { [unitId]: { cbo, weeklyHours } }
    units: {}
  };
}

function toProfile(data) {
  const units = {};
  (data.Units || []).forEach((unit) => {
    units[String(unit.UnitId)] = {
      cbo: unit.Cbo || "",
      weeklyHours: unit.WeeklyHours == null ? "" : unit.WeeklyHours
    };
  });
  return {
    cns: data.Cns || "",
    certificateType: data.CertificateType || "",
    certificateHours: data.CertificateHours == null ? "" : data.CertificateHours,
    units
  };
}

export async function getProfessionalProfile(professionalId) {
  return toProfile(await apiGet(`/professionals/${professionalId}/profile`));
}

/**
 * Salva o perfil. `unitIds` são as equipes a que o profissional está vinculado agora:
 * a API só aceita vínculos atuais e não apaga o CBO e as horas de equipes fora da lista.
 */
export async function saveProfessionalProfile(professionalId, profile, unitIds) {
  const blank = (value) => value === "" || value === null || value === undefined;
  return toProfile(await apiPut(`/professionals/${professionalId}/profile`, {
    Cns: profile.cns || null,
    CertificateType: profile.certificateType || null,
    CertificateHours: profile.certificateType && !blank(profile.certificateHours) ? Number(profile.certificateHours) : null,
    Units: unitIds.map((unitId) => {
      const unit = profile.units[String(unitId)] || {};
      return {
        UnitId: Number(unitId),
        Cbo: unit.cbo || null,
        WeeklyHours: blank(unit.weeklyHours) ? null : Number(unit.weeklyHours)
      };
    })
  }));
}

/** CBO do profissional para sugerir em registros (o primeiro informado nas equipes). */
export async function getFirstCbo(professionalId) {
  try {
    const profile = await getProfessionalProfile(professionalId);
    const withCbo = Object.values(profile.units).find((unit) => unit.cbo);
    return withCbo ? withCbo.cbo : "";
  } catch (error) {
    return "";
  }
}
